import { post } from "./DataService.js";

export const postLoginCredentials = (credentials) => {
  return post("/api/auth/login", credentials);
};

export const postCustomerRegistration = (registrationData) => {
  return post("/api/auth/register", registrationData);
};
